import { Injectable } from "@angular/core";
import { IDocument } from "app/bundles/requests/shared/models/document";
import { ReturnDDSDocument } from "app/bundles/requests/shared/models/returnDDSDocument";
import * as _ from "lodash-es";
import { Observable, of } from "rxjs";
import {
  IRawServiceRequestDetail,
  IRawServiceRequestSummary,
  IWorkorderRequestDetail,
  IWorkorderRequestShallowDetail,
  IWorkorderRequestSummary,
} from "../../models/request";
import {
  mockedServiceRequestGetAll,
  mockedServiceRequestsGetById,
  mockedWorkordersForeman,
  mockedWorkordersGetAll,
  mockedWorkordersGetById,
} from "./request-api.mock-constants";
import { RequestApi } from "./request-api.models";

@Injectable()
export class MockRequestApiService extends RequestApi {
  constructor() {
    super();
  }

  public getWorkorderById(
    id: number,
  ): Observable<IWorkorderRequestShallowDetail> {
    const workorder = mockedWorkordersGetById.find((a) => a.id === +id);
    return of(workorder);
  }

  public getServiceRequestById(
    id: number,
  ): Observable<IRawServiceRequestDetail> {
    const serviceRequest = mockedServiceRequestsGetById.find(
      (a) => a.serviceRequestId === id,
    );
    return of(serviceRequest);
  }

  public getDocumentsByWorkorderId(id: number): Observable<IDocument[]> {
    return of(mockedWorkordersForeman);
  }

  public addDocumentByWorkorderId(id: string, document: any): Observable<any> {
    return of([]);
  }

  public getWorkorderGeojsonData(): Observable<any> {
    return of(mockedWorkordersGetAll);
  }

  public getServiceRequestGeojsonData(): Observable<any> {
    return of(_.cloneDeep(mockedServiceRequestGetAll));
  }

  public returnDDS(id: number, document: ReturnDDSDocument): Observable<any> {
    return of([]);
  }
}
